








































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import _ from 'lodash'
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import draggable from 'vuedraggable';
import { BModal } from 'bootstrap-vue';
import { SheetActivity, StudentDetail } from "../../modules/teacher/SheetUpload"
import { Student } from '../../modules/teacher/StudentList';


export interface Data {
  sheet_id: string
  sheet: any
  students: StudentDetail[]
  currentStudent: StudentDetail | null
  currentSheetActivity: SheetActivity | null
  currentStudentIdx: number
  currentSheetActivityIdx: number
  errors: string[]
  pageErrors: string[]
  scale: number
  rotates: number[]
  file: any,
  modalStudent: StudentDetail | null,
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "draggable": draggable,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/
    const modalSheetUploadRef = ref<InstanceType<typeof BModal>>();
    const modalSwapPageRef = ref<InstanceType<typeof BModal>>();


    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      sheet_id: "",
      sheet: {field_positions_completed: true},
      students: [],
      currentStudent: null,
      currentSheetActivity: null,
      currentStudentIdx: 0,
      currentSheetActivityIdx: 0,
      errors: [],
      pageErrors: [],
      scale: 0.5,
      rotates: [0, 90, 180, 270],
      file: null,
      modalStudent: null,
    });


    /******************************
     * computed
     ******************************/

    // 答案アップロード済みの受験者リスト
    const uploadedStudents = computed((): StudentDetail[] => {
      return state.students.filter((x: StudentDetail) => x.sheetActivities.length > 0);
    });

    // 答案アップロード未の受験者リスト
    const unUploadedStudents = computed((): StudentDetail[] => {
      return state.students.filter((x: StudentDetail) => x.sheetActivities.length == 0);
    });

    // imgタグのスタイル
    const imageStyle = computed((): object => {
      let style: any = {};
      const sheetActivitiy: SheetActivity | null = state.currentSheetActivity;
      if(sheetActivitiy != null){
        style["width"] = `${sheetActivitiy.baseWidth * state.scale}px`;
        style["height"] = `${sheetActivitiy.baseHeight * state.scale}px`;
        style["transform"] = `rotate(${sheetActivitiy.angle}deg)`;
        
        // 回転の中心軸設定
        let translateX: string = "";
        let translateY: string = "";
        if(sheetActivitiy.angle == 90){
          translateX = `${sheetActivitiy.baseHeight * state.scale / 2}px`;
          translateY = `${sheetActivitiy.baseHeight * state.scale / 2}px`;
        }else if(sheetActivitiy.angle == 180){
          translateX = `${sheetActivitiy.baseWidth * state.scale / 2}px`;
          translateY = `${sheetActivitiy.baseHeight * state.scale / 2}px`;
        }else if(sheetActivitiy.angle == 270){
          translateX = `${sheetActivitiy.baseWidth * state.scale / 2}px`;
          translateY = `${sheetActivitiy.baseWidth * state.scale / 2}px`;
        }
        style["transform-origin"]  = `${translateX} ${translateY}`;
      }
      
      return style;
    });

    // imgの親divのスタイル
    const imageWrapStyle = computed((): object => {
      let style: any = {};
      const sheetActivitiy: SheetActivity | null = state.currentSheetActivity;
      if(sheetActivitiy != null){
        if(sheetActivitiy.angle == 0 || sheetActivitiy.angle == 180){
          style["height"] = `${(sheetActivitiy.baseHeight * state.scale) + 30}px`;
        }else{
          style["height"] = `${(sheetActivitiy.baseWidth * state.scale) + 30}px`;
        }
      }
      return style;
    });


    /******************************
     * methods
     ******************************/

    // 選択答案情報切り替え
    const changeCurrent = async (studentIdx: number, sheetActivityIdx: number) => {
      state.currentStudent = uploadedStudents.value[studentIdx];
      state.currentSheetActivity = state.currentStudent.sheetActivities[sheetActivityIdx];
      state.currentStudentIdx = studentIdx;
      state.currentSheetActivityIdx = sheetActivityIdx;
      state.currentSheetActivity.angle = 0;

      // 画像がキャッシュされていない場合はAPIでダウンロード
      if(state.currentSheetActivity.base64Image == null){
        const param: object = {
          sheet_id: state.sheet_id,
          sheet_activity_id: state.currentSheetActivity.id,
          page: state.currentSheetActivityIdx + 1,
          room_name: state.currentStudent.room_name,
          student_no: state.currentStudent.number
        };
        await http.get(`/api/sheet_upload/download_image?${Common.BuildQuery(param, "")}`).then(response => {
          state.currentSheetActivity.base64Image = response.data.base64_image;
          state.currentSheetActivity.baseWidth = response.data.image_size_hash["width"];
          state.currentSheetActivity.baseHeight = response.data.image_size_hash["height"];
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      }
    };

    // 拡大ボタン押下
    const scaleUp = () => {
      state.scale += 0.05;
    };

    // 縮小ボタン押下
    const scaleDown = () => {
      if(state.scale > 0.1){
        state.scale -= 0.05;
      }
    };

    // 画像を表示エリアの横幅に合わせる
    const adjustWidth = () => {
      const elem = document.getElementById("image-area");
      if(elem != null){
        const imageAreaW = elem.clientWidth;
        state.scale = imageAreaW / state.currentSheetActivity.baseWidth;
      }
    };

    // 画面サイズに合わせてレイアウト整形
    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      const imageArea = document.getElementById("image-area");

      if(tableArea != null && imageArea != null){
        tableArea.style.height = (winH - tableArea.offsetTop) + "px";
        imageArea.style.height = (winH - imageArea.offsetTop) + "px";
      }
    };

    // 前へボタン押下
    const prevCurrent = () => {
      if(state.currentSheetActivityIdx > 0){
        changeCurrent(state.currentStudentIdx, state.currentSheetActivityIdx -1);
      }else{
        for(var i = state.currentStudentIdx - 1; i >= 0; i--){
          if(uploadedStudents.value[i].sheetActivities != null && uploadedStudents.value[i].sheetActivities.length > 0){
            changeCurrent(i, state.sheet.page_count - 1);
            break;
          }
        }
      }
    };

    // 次へボタン押下
    const nextCurrent = () => {
      if(state.sheet.page_count > state.currentSheetActivity.page){
        changeCurrent(state.currentStudentIdx, state.currentSheetActivityIdx + 1);
      }else{
        for(var i = state.currentStudentIdx + 1; i < uploadedStudents.value.length; i++){
          if(uploadedStudents.value[i].sheetActivities != null && uploadedStudents.value[i].sheetActivities.length > 0){
            changeCurrent(i, 0);
            break;
          }
        }
      }
    };

    // 左回転ボタン押下
    const rotateLeft = async (): Promise<void> => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.currentSheetActivity.angle);
      if(rotateIdx == 0){
        angle = 270;
      }else{
        angle = state.currentSheetActivity.angle - 90;
      }
      state.currentSheetActivity.angle = angle;

      await rotateSave(false, false);
    };

    // 右回転ボタン押下
    const rotateRight = async (): Promise<void> => {
      let angle = 0;
      const rotateIdx = state.rotates.indexOf(state.currentSheetActivity.angle);
      if(rotateIdx == 3){
        angle = 0;
      }else{
        angle = state.currentSheetActivity.angle + 90;
      }
      state.currentSheetActivity.angle = angle;

      await rotateSave(false, false);
    };

    // 回転保存ボタン押下
    const rotateSave = async (isConfirmMsg: boolean = true, isResutMsg: boolean = true) => {
      
      if(state.currentSheetActivity.angle == 0){
        alert("回転情報は変更されていません。");
        return;
      }
      
      if(isConfirmMsg && !window.confirm(`回転状態を保存します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param: object = {
        sheet_activity_id: state.currentSheetActivity.id,
        angle: state.currentSheetActivity.angle,
        page: state.currentSheetActivityIdx + 1,
        room_name: state.currentStudent.room_name,
        number: state.currentStudent.number
      };

      await http.post(`/api/sheet_upload/rotate/${state.sheet_id}`, param).then(response => {
        if (isResutMsg) {
          alert("処理が完了しました。");
        }
        state.currentSheetActivity.base64Image = response.data.base64_image;
        state.currentSheetActivity.baseWidth = response.data.image_size_hash.width;
        state.currentSheetActivity.baseHeight = response.data.image_size_hash.height;
        state.currentSheetActivity.angle = 0;
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }

        // 画面再表示
        await created();
      });

      context.root.$store.dispatch("hideOverlay");
    };

    // 一括回転
    const rotateAll = async (angle: number) => {

      if(!window.confirm(`${state.currentSheetActivity.page}ページ目の一括回転を実行します。よろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param: object = {
        sheet_id: state.sheet_id,
        sheet_activity_id: state.currentSheetActivity.id,
        angle: angle,
        page: state.currentSheetActivityIdx + 1,
      };

      await http.post(`/api/sheet_upload/rotate_all/${state.sheet_id}`, param).then(response => {

        // キャッシュ済みの答案画像をクリア
        state.students.forEach((e: StudentDetail) => {
          e.sheetActivities.forEach((s: SheetActivity) => {
            s.base64Image = null;
            s.baseWidth = 0;
            s.baseHeight = 0;
          });
        });

        state.currentSheetActivity.base64Image = response.data.base64_image;
        state.currentSheetActivity.baseWidth = response.data.image_size_hash.width;
        state.currentSheetActivity.baseHeight = response.data.image_size_hash.height;
        state.currentSheetActivity.angle = 0;

        alert("処理が完了しました。");
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
        // 画面再表示
        await created();
      });

      context.root.$store.dispatch("hideOverlay");
    };

    // 欠席者モーダル表示
    const showAbsentModal = (file: any) => {
      state.file = file;
      modalSheetUploadRef.value.show();
    };

    // アップロードモーダル閉じる
    const closeSheetUploadModal = () => {
      modalSheetUploadRef.value.hide();
      unUploadedStudents.value.forEach((x: StudentDetail) => {
        x.isAbsent = false;
      });
    };

    // 並び順確認ボタン押下
    // const toSortAnswerImage = () => {
    //   context.root.$router.push(`/teacher_site/sort_answer_image/${state.sheet_id}`).catch(err => {});
    // }

    // 答案アップロード
    const upload = async () => {

      modalSheetUploadRef.value.hide();

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }
      
      // 登録対象の生徒リスト取得
      let students: any[] = [];
      unUploadedStudents.value.filter((x: StudentDetail) => !x.isAbsent).forEach((x: StudentDetail) => {
        students.push({'user_id': x.user_id, 'room_name': x.room_name, 'number': x.number});
      });

      if(students.length == 0){
        alert("登録対象が0名です。");
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', state.file);
      fd.append('students', JSON.stringify(students));

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/sheet_upload/upload/${state.sheet_id}`, fd).then(response => {
        
        state.sheet = response.data.sheet;
        state.students = response.data.students.map((x: any) => new StudentDetail(x, response.data.sheet.sheet_activities));
        if(uploadedStudents.value.length > 0){
          changeCurrent(0, 0);
        }
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      unUploadedStudents.value.forEach((x: StudentDetail) => {
        x.isAbsent = false;
      });

      context.root.$store.dispatch("hideOverlay");
    };

    // ページ並び替えモーダル表示
    const showSwapPageModal = async (student: StudentDetail) => {

      state.modalStudent = _.cloneDeep(student);

      state.pageErrors = [];

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      for(var i = 0; i < state.modalStudent.sheetActivities.length; i++){
        
        let sheetActivity: SheetActivity = state.modalStudent.sheetActivities[i];

        // 画像がキャッシュされていない場合はAPIでダウンロード
        if(sheetActivity.base64Image == null){
          const param: object = {
            sheet_id: state.sheet_id,
            sheet_activity_id: sheetActivity.id,
            page: sheetActivity.page,
            room_name: state.modalStudent.room_name,
            student_no: state.modalStudent.number
          };
          await http.get(`/api/sheet_upload/download_image?${Common.BuildQuery(param, "")}`).then(response => {
            sheetActivity.base64Image = response.data.base64_image;
            sheetActivity.baseWidth = response.data.image_size_hash["width"];
            sheetActivity.baseHeight = response.data.image_size_hash["height"];
          })
          .catch(error=>{
            if(error.response.status == 422){
              state.pageErrors = error.response.data.errors;
            }else{
              state.pageErrors = ["予期せぬ例外が発生しました。"];
            }
          });
        }
      }

      context.root.$store.dispatch("hideOverlay");

      modalSwapPageRef.value.show();
    };

    // ページ並び替えモーダル閉じる
    const closeSwapPageModal = () => {
      modalSwapPageRef.value.hide();
    };

    // ドラッグ変更後
    const onChangePage = (change: any) => {
      let moved = change.moved;
      if(moved) {
        // ページ番号が入れ替わってしまうので元に戻す
        let oldPageNo = state.modalStudent.sheetActivities[moved.oldIndex].page;
        let newPageNo = state.modalStudent.sheetActivities[moved.newIndex].page;
        state.modalStudent.sheetActivities[moved.oldIndex].page = newPageNo;
        state.modalStudent.sheetActivities[moved.newIndex].page = oldPageNo;
      }
    };

    // ページ並び替え実行
    const completeSwapPage = async () => {

      state.pageErrors = [];

      // ページが変更されているかどうか
      let oldSheetActivities = uploadedStudents.value.filter((x: StudentDetail) => x.user_id == state.modalStudent.user_id)[0].sheetActivities;
      let isChange = false;
      state.modalStudent.sheetActivities.forEach((x: SheetActivity) => {
        if (oldSheetActivities.filter((y: SheetActivity) => x.id == y.id && x.page == y.page).length == 0) {
          isChange = true
          return;
        }
      });
      if(!isChange){
        state.pageErrors.push("ページが変更されていません。");
        return;
      }

      if(!window.confirm(`ページの並び替えを保存します。よろしいですか？`)){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      let sheetActivities: any[] = [];
      state.modalStudent.sheetActivities.forEach((x: SheetActivity) => {
        sheetActivities.push({"id": x.id, "page": x.page});
      });;

      await http.post(`/api/sheet_upload/move_page_update/${state.sheet_id}}`, {sheet_activities: sheetActivities}).then(response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.pageErrors = error.response.data.errors;
        }else{
          state.pageErrors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    // 答案削除ボタン押下
    const destroy = async (student: StudentDetail) => {
      if(!window.confirm(`組${student.room_name}組、番号${student.number}番の答案を削除します。よろしいですか？`)){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/sheet_upload/destroy/${state.sheet_id}/${student.user_id}`).then(response => {
        
        student.sheetActivities = new Array<SheetActivity>();
        if(uploadedStudents.value.length > 0){
          changeCurrent(0, 0);
        }

        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    // 一括削除ボタン押下
    const destroyAll = async () => {

      if(uploadedStudents.value.length == 0){
        alert("削除対象が存在しません。");
        return;
      }

      if(!window.confirm("答案を一括削除します。よろしいですか？")){
        return;
      }

      state.errors = [];
      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/sheet_upload/destroy_all/${state.sheet_id}`).then(response => {
        
        state.students.forEach(x => {
          x.sheetActivities = new Array<SheetActivity>();
        });

        state.currentStudent = null;
        state.currentSheetActivity = null;

        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    // 切り出しボタン押下
    const imageCut = async () => {

      if(!window.confirm("切り出しを実行します。よろしいですか？")){
        return;
      }

      await http.post(`/api/sheet_upload/create_cut_job/${state.sheet_id}`).then(response => {
        alert("答案切り出しを開始しました");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    // keyUpイベント
    const keyUp = (e: KeyboardEvent): void => {

      if (e.key == "ArrowDown") {
        e.preventDefault();

        if (state.currentStudentIdx < (uploadedStudents.value.length - 1)) {
          changeCurrent(state.currentStudentIdx + 1, state.currentSheetActivityIdx);
        }
        return;
      }

      if (e.key == "ArrowUp") {
        e.preventDefault();

        if (state.currentStudentIdx > 0) {
          changeCurrent(state.currentStudentIdx - 1, state.currentSheetActivityIdx);
        }

        return;
      }

      if (e.key == "ArrowLeft") {
        e.preventDefault();

        if (state.currentSheetActivity.page > 1) {
          changeCurrent(state.currentStudentIdx, state.currentSheetActivityIdx - 1);
        }

        return;
      }
      
      if (e.key == "ArrowRight") {
        e.preventDefault();
        
        if (state.currentSheetActivity.page < state.sheet.page_count) {
          changeCurrent(state.currentStudentIdx, state.currentSheetActivityIdx + 1);
        }

        return;
      }
    }

    /******************************
     * created
     ******************************/

    const created = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;

      await http.get(`/api/sheet_upload?sheet_id=${state.sheet_id}`).then(response => {
        if(response.data.sheet.field_positions_completed){
          adjustHeight();
          window.addEventListener("resize", adjustHeight);
        }
        
        state.sheet = response.data.sheet;
        state.students = response.data.students.map((x: any) => new StudentDetail(x, response.data.sheet.sheet_activities));
        if(uploadedStudents.value.length > 0){
          changeCurrent(0, 0);
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });

      window.addEventListener("keyup", keyUp);

      context.root.$store.dispatch("hideOverlay");
    };

    // created処理呼び出し
    created();

    /******************************
     * mounted
     ******************************/

    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("keyup", keyUp);
    });

    return {
      ...toRefs(state),
      modalSheetUploadRef,
      modalSwapPageRef,
      uploadedStudents,
      unUploadedStudents,
      imageStyle,
      imageWrapStyle,
      changeCurrent,
      scaleUp,
      scaleDown,
      adjustWidth,
      adjustHeight,
      prevCurrent,
      nextCurrent,
      rotateLeft,
      rotateRight,
      rotateSave,
      rotateAll,
      closeSheetUploadModal,
      showAbsentModal,
      upload,
      showSwapPageModal,
      closeSwapPageModal,
      onChangePage,
      completeSwapPage,
      destroyAll,
      destroy,
      imageCut,
      KeyboardEvent,
      keyUp,
    };
  }
})
